import css from './table-row.module.css'

export const styles = {
  base: css.row,
}
